import {
    getReconciliationReport,
    listReconciliationReports,
} from './queries';

import {GraphQLQuery} from '@aws-amplify/api';
import {BillingChannel, ReconciliationReport} from "../types.ts";
import {billingApiClient} from "../../billing-api-integration";

export type ListReconciliationReports = {
    listReconciliationReports: { items: ReconciliationReport[], nextToken: string }
}

export type GetReconciliationReport = {
    getReconciliationReport: ReconciliationReport
}

const client = billingApiClient;

// FNP-535: read-only module. No create/update/delete — the ChannelReconciler (Job B,
// IAM-only) owns the lifecycle. listReconciliationReports is the single list query
// (channel-runStartedAt-index, newest-first). channel is REQUIRED (the GSI partition
// key), so this list — unlike the sibling sweep modules — is always scoped to one
// channel, supplied by the channel selector (default STRIPE).
export const fetchRecords = async (query: { channel: BillingChannel, limit?: number, nextToken?: string | null }) => {
    const {channel, limit, nextToken} = query;

    const response = await client.graphql<GraphQLQuery<ListReconciliationReports>>({
        query: listReconciliationReports,
        variables: {
            channel,
            limit,
            nextToken,
        },
    });
    return {
        // Guard against a GraphQL-level error (response.data undefined), so the hook
        // always receives a real array, never an undefined item (the FNP-539 backstop).
        items: response.data?.listReconciliationReports.items ?? [],
        nextToken: response.data?.listReconciliationReports.nextToken,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetReconciliationReport>>({
        query: getReconciliationReport,
        variables: {id: id},
    });
    return response.data?.getReconciliationReport;
};
